import { BOOK_WIDGET_ERROR_CODES } from '../../constants/error-codes.constants';
import { PriceTypes } from '../../constants/postData.constants';
import { PostDataSearchLocalStorage } from '../../models/postData-search-local-storage.interface';
import { UpdateSearchApiMultiCityPayload } from '../../models/states/update-search-state.interfaces';
import { trackErrorInTrackJs } from '../utils/utils.adapter';
import {
  getDateInMMDDYYFormat,
  getPassengerCountInformation
} from './update-search-api.adapter';

export const prepareUpdateSearchApiMultiCityPayload = (
  postData: PostDataSearchLocalStorage
): UpdateSearchApiMultiCityPayload | null => {
  try {
    const { adtCount, passengerCount } = getPassengerCountInformation(
      postData.passengers
    );
    // eslint-disable-next-line complexity
    const airports = postData.segments.map((segment) => ({
      fromCity: segment.originCity || '',
      toCity: segment.destinationCity || '',
      fromAirportcode: segment.origin || '',
      toAirportcode: segment.destination || '',
      connectionAirport: segment.connectionAirportCode || '',
      connectionCity: '',
      invalidAirportCodes: '',
      fromCountryCode: segment.originCountryCode || '',
      toCountryCode: segment.destinationCountryCode || ''
    }));

    const dates = postData.segments.map((segment) => ({
      departureDate: getDateInMMDDYYFormat(segment.departureDate),
      returnDate: segment.returnDate
        ? getDateInMMDDYYFormat(segment.returnDate)
        : ''
    }));

    const payload: UpdateSearchApiMultiCityPayload = {
      cacheKey: postData.cacheKey,
      value: {
        adtCount,
        adtGbeCount: '',
        airports,
        awardTravel: postData.priceType === PriceTypes.AWARD,
        cnnCount: 0,
        dates,
        deltaOnly: '',
        departureTime: '',
        faresFor: postData.bestFare,
        flightHotelDeals: '',
        gbeCount: 0,
        infantCount: 0,
        maxPaxCount: '',
        meetingEventCode: postData.meetingEventCode,
        nearbyAirports: '',
        optionals: '',
        passenger: passengerCount,
        refundableFlightsOnly: postData.refundableFlightsOnly ? 'true' : '',
        returnTime: '',
        schedulePrice: postData.shopType || '',
        selectTripType: postData.tripType,
        swapedFromCity: '',
        swapedToCity: '',
        includeBasicFaresUnchecked: postData.includeBasicFaresUnchecked
      }
    };
    return payload;
  } catch (error) {
    trackErrorInTrackJs(
      BOOK_WIDGET_ERROR_CODES.SLIM_NAV_MULTICITY_PAYLOAD_ERROR,
      JSON.stringify(error)
    );
    return null;
  }
};
